import React from "react";
import { Modal as AntdModal } from "antd";

/**
 * API (no TypeScript):
 * - open (preferred) or isVisible (alias)
 * - setIsVisible (alias to close on cancel)
 * - size: "sm" | "md" | "lg" | "xl" | "full"  (maps to width)
 * - width: number | string (overrides size)
 * - bodyMaxHeight: string (e.g., "70vh")
 * - styles: AntD v5 styles override (header/body/footer)
 * - ...rest: any other AntD Modal props
 */
const SIZE_WIDTH = {
  sm: 420,
  md: 640,
  lg: 900,
  xl: 1200,
  full: "100vw",
};

export default function Modal(props) {
  const {
    children,
    title,
    open,
    isVisible, // alias
    setIsVisible, // alias for closing
    size = "md",
    width,
    bodyMaxHeight,
    styles,
    onCancel,
    ...rest
  } = props;

  const resolvedOpen = typeof open !== "undefined" ? open : !!isVisible;
  const computedWidth = typeof width !== "undefined" ? width : SIZE_WIDTH[size];
  const isFull = size === "full" || computedWidth === "100vw";

  const mergedStyles = {
    ...(styles || {}),
    body: {
      ...(styles && styles.body ? styles.body : {}),
      maxHeight: bodyMaxHeight || (isFull ? "calc(100vh - 120px)" : "80vh"),
      overflowY: "auto",
    },
  };

  const handleCancel = (e) => {
    if (typeof onCancel === "function") onCancel(e);
    if (typeof setIsVisible === "function") setIsVisible(false);
  };

  return (
    <AntdModal
      title={title}
      centered={!isFull}
      open={resolvedOpen}
      width={computedWidth}
      onCancel={handleCancel}
      footer={false}
      style={isFull ? { top: 0, paddingBottom: 0 } : undefined}
      styles={mergedStyles}
      {...rest}
    >
      {children}
    </AntdModal>
  );
}
